import cn from 'classnames';

import Meatballs from 'components/icons/Meatballs';
import OnePanMeals from 'components/icons/OnePanMeals';
import Pasta from 'components/icons/Pasta';
import RiceBowl from 'components/icons/RiceBowl';
import RotisserieChicken from 'components/icons/RotisserieChicken';
import Salmon from 'components/icons/Salmon';
import SteakStrips from 'components/icons/SteakStrips';
import Tacos from 'components/icons/Tacos';
import useAnalyticsCallback from 'hooks/useAnalyticsCallback';
import useAnalyticsEffect from 'hooks/useAnalyticsEffect';
import { POPULAR_SEARCHES, TEMPO } from 'lib/constants';
import style from 'styles/components/menuSearch/MealsNotFound';

const MealsNotFound = ({ handleSearch, mealPlanSlug, searchTerm }) => {
  useAnalyticsEffect(
    ({ logEvent, events }) => {
      logEvent(events.menuSearch.recipeSearchNoResultsViewed, {
        searchTerm: searchTerm,
        mealPlanSlug: mealPlanSlug,
      });
    },
    [mealPlanSlug]
  );

  const handleSearchWithAnalytics = useAnalyticsCallback(
    search => handleSearch({ params: { searchTerm: search } }),
    ({ logEvent, events, callbackArgs }) =>
      logEvent(events.menuSearch[`recipeSearch${callbackArgs[0].replace(/ /g, '')}Clicked`], {
        search_term: searchTerm,
        mealPlanSlug: mealPlanSlug,
      }),
    [searchTerm, mealPlanSlug]
  );
  const isTempo = mealPlanSlug === TEMPO;

  const noResultsFound = POPULAR_SEARCHES[mealPlanSlug];

  const iconMapping = {
    chicken: RotisserieChicken,
    'rice bowl': RiceBowl,
    tacos: Tacos,
    'one-pan meals': OnePanMeals,
    'steak strips': SteakStrips,
    beef: SteakStrips,
    salmon: Salmon,
    meatballs: Meatballs,
    pasta: Pasta,
  };

  const getIcon = search => {
    return iconMapping[search.toLowerCase()];
  };

  return (
    <div className="flex justify-center">
      <div className="w-5/6 p-6 text-center">
        <h3 className="h4 mb-2">
          We couldn't find any {mealPlanSlug === TEMPO ? 'meals' : 'recipes'} matching "{searchTerm}
          "
        </h3>
        <h4 className={cn(style.menuSearchAgain, 'text mb-8', { tempo: isTempo })}>
          Search again or try one of these popular searches:
        </h4>
        <div className="bp-1:mb-12 mb-8 flex flex-wrap justify-center bp1:flex-row bp1:justify-center">
          {noResultsFound.map(search => {
            const Icon = getIcon(search);
            return (
              <button
                onClick={() => handleSearchWithAnalytics(search)}
                className={cn(
                  style.popularRecipeButton,
                  'btn btnSm mb-2 ml-1 h-10 whitespace-nowrap rounded-full border-none bg-charcoal-50 px-3 text-charcoal-100 hover:bg-charcoal-60'
                )}
                key={`popular-search-button-${search}`}
              >
                {Icon && <Icon className="icon iconMd mb-1 mr-1" />}
                {search}
              </button>
            );
          })}
        </div>
        <h4 className={cn(style.menuSearchAgain, { 'tempo text': isTempo })}>
          Have questions about our products and service?{' '}
          <a
            className="linkTextPrimary"
            href="https://support.homechef.com/hc/en-us"
            target="_blank"
            rel="noopener noreferrer"
          >
            View our FAQs
          </a>
        </h4>
      </div>
    </div>
  );
};

MealsNotFound.propTypes = {
  searchTerm: PropTypes.string,
  handleSearch: PropTypes.func.isRequired,
  mealPlanSlug: PropTypes.string.isRequired,
};

export default MealsNotFound;
